import { Button, OptionList, Popover } from '@shopify/polaris';
import { useState } from 'react';

// Botón con dropdown single-select. Pensado para combinarse en un
// `<ButtonGroup segmented>` con otros del mismo tipo, igual que los
// FilterSelect multi-valor para verse unidos visualmente.
export const SingleSelectButton = ({ options, value, onChange }) => {
  const [active, setActive] = useState(false);
  const current = options.find((o) => o.value === value);
  const activator = (
    <Button onClick={() => setActive((s) => !s)} disclosure primary>
      {current?.label ?? '—'}
    </Button>
  );
  return (
    <Popover active={active} activator={activator} onClose={() => setActive(false)}>
      <OptionList
        onChange={(sel) => {
          if (sel[0] !== undefined) onChange(sel[0]);
          setActive(false);
        }}
        options={options}
        selected={value ? [value] : []}
      />
    </Popover>
  );
};
